import { Check } from "lucide-react";

export function FlowStepper({ steps, current, onSelect, testid = "flow" }) {
  return (
    <div className="flex flex-wrap items-center gap-y-3" data-testid={testid}>
      {steps.map((s, i) => {
        const done = i < current, active = i === current;
        return (
          <div key={s} className="flex items-center">
            <button
              type="button"
              data-testid={`${testid}-step-${i}`}
              onClick={onSelect ? () => onSelect(i) : undefined}
              className={`flex h-8 items-center gap-2 rounded-lg border px-2.5 text-xs font-medium transition-colors ${
                active ? "border-zinc-900 bg-zinc-900 text-white" : done ? "border-zinc-200 bg-white text-zinc-700" : "border-dashed border-zinc-200 bg-transparent text-zinc-400"
              } ${onSelect ? "hover:border-zinc-400" : "cursor-default"}`}
            >
              <span className={`flex h-4 w-4 items-center justify-center rounded font-mono text-[9px] ${active ? "bg-white/15" : done ? "bg-emerald-500 text-white" : "bg-zinc-100"}`}>
                {done ? <Check className="h-2.5 w-2.5" /> : i + 1}
              </span>
              {s}
            </button>
            {i < steps.length - 1 && <div className={`mx-1 h-px w-4 ${done ? "bg-zinc-400" : "bg-zinc-200"}`} />}
          </div>
        );
      })}
    </div>
  );
}
